module.exports = __webpack_public_path__ + "img/wangzhe.da9f195d.png";